// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".highlight-module__container--3Bes5{color:#183323;background-color:#afdaff}\n", ""]);
// Exports
exports.locals = {
	"container": "highlight-module__container--3Bes5"
};
module.exports = exports;
